import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import imgs from '../../../../assets/images/logoCompras.png';
import login from '../../../../services/Login/LoginService';
import { errorNotification, saveNotification } from 'utils/toastify';
import portada from '../../../../assets/images/portadaLogin.jpg';

import { LoadingButton } from '@mui/lab';
import { useAuth } from 'Contextos/AuthContext';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props} sx={{ mt: 4, opacity: 0.8 }}>
            {'Copyright © '}
            <Link color="inherit" href="#" sx={{ fontWeight: 600 }}>
                Corporación Adventista
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
    );
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#0277bd',
        },
    },
});

export default function LogIn(props) {
    const [loading, setLoading] = React.useState(false);
    const { logInContext } = useAuth();

    const handleSubmit = (event) => {
        event.preventDefault();
        localStorage.setItem('go', true);
        const data = new FormData(event.currentTarget);
        const dataSend = {
            codigoUsuario: data.get('codigoUsuario'),
            contrasena: data.get('contrasena')
        };
        setLoading(true);

        login
            .Post(dataSend)
            .then(async (result) => {
                if (result.code === '1') {
                    const resp = result.payload;
                    localStorage.setItem('roles', JSON.stringify(resp.roles));
                    localStorage.setItem('go', false);
                    localStorage.setItem('JWT', JSON.stringify('Bearer ' + resp.token));
                    if (resp.refreshToken) {
                        localStorage.setItem('refreshToken', JSON.stringify(resp.refreshToken));
                    } else {
                        localStorage.setItem('refreshToken', JSON.stringify(resp.token));
                    }
                    localStorage.setItem('codigoUsuario', JSON.stringify(data.get('codigoUsuario')));
                    localStorage.setItem('user', JSON.stringify(resp.user));
                    localStorage.setItem('idSucursal', JSON.stringify(resp.idSucursal));
                    localStorage.setItem('nombreSucursal', JSON.stringify(resp.nombreSucursal));
                    localStorage.setItem('nombreRolTipo', JSON.stringify(resp.nombreRol));
                    localStorage.setItem('codigoRolTipo', JSON.stringify(resp.codigoRolTipo));
                    localStorage.setItem('ambiente', JSON.stringify(resp.ambiente));
                    localStorage.setItem('idRol', JSON.stringify(resp.idRol));
                    localStorage.setItem('idUsuario', JSON.stringify(resp.idUsuario));
                    localStorage.setItem('hour', JSON.stringify(3));
                    localStorage.setItem('minute', JSON.stringify(54));
                    localStorage.setItem('second', JSON.stringify(59));
                    localStorage.setItem('isAuthenticated', 'true');
                    setLoading(false);
                    startSesion(result.redirectTo, login.verifyLogin());
                } else {
                    setLoading(false);
                    errorNotification(result.message);
                }
            })
            .catch((e) => {
                errorNotification('El servicio no esta funcionando');
                console.log('error server');
                setLoading(false);
            });

        const startSesion = (ruta, valor) => {
            if (!valor) {
                logInContext();
                window.location.href = ruta;
                saveNotification('Acceso correcto');
            }
        };
    };

    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <ThemeProvider theme={theme}>
            <Grid
                container
                component="main"
                sx={{
                    minHeight: '100vh',
                    width: '100%',
                    m: 0,
                    p: 0,
                    backgroundColor: '#f5f5f5',
                    overflowX: 'hidden',
                    display: 'flex',
                    flexDirection: 'row' // Mantenemos row para que sm+ funcione bien
                }}
            >
                <CssBaseline />

                {/* PANEL DE MARCA: Visible solo en Tablet y Desktop (sm en adelante) */}
                <Grid
                    item
                    xs={false} // Oculta en XS
                    sm={4}
                    md={7}
                    sx={{
                        display: { xs: 'none', sm: 'flex' }, // Reforzamos la ocultación en XS
                        position: 'relative',
                        minHeight: '100vh',
                        backgroundImage: `linear-gradient(rgba(2, 119, 189, 0.4), rgba(0, 0, 0, 0.6)), url(${portada})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 3,
                        boxSizing: 'border-box'
                    }}
                >
                </Grid>

                {/* PANEL DE FORMULARIO: Ocupa 100% en móvil (xs=12) y centrado */}
                <Grid
                    item
                    xs={12}
                    sm={8}
                    md={5}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100vh', // Asegura centrado vertical en móvil
                        p: { xs: 2, sm: 4 },
                        boxSizing: 'border-box'
                    }}
                >
                    <Paper
                        elevation={10}
                        sx={{
                            p: { xs: 3, sm: 6 },
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            borderRadius: '24px',
                            width: '100%',
                            maxWidth: '420px',
                            background: '#ffffff',
                            boxSizing: 'border-box',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)'
                        }}
                    >
                        <Avatar
                            src={imgs}
                            variant="square"
                            sx={{
                                width: { xs: 110, md: 140 },
                                height: 'auto',
                                mb: { xs: 2, md: 3 },
                            }}
                        />

                        <Typography
                            component="h1"
                            variant="h4"
                            sx={{
                                fontWeight: 600,
                                color: '#333',
                                mb: 1,
                                fontSize: { xs: '1.5rem', md: '2.125rem' }
                            }}
                        >
                            Iniciar Sesión
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 3, textAlign: 'center' }}>
                            Ingresa tus credenciales para continuar
                        </Typography>

                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ width: '100%', m: 0, p: 0 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="codigoUsuario"
                                label="Usuario"
                                name="codigoUsuario"
                                autoComplete="codigoUsuario"
                                autoFocus
                                InputProps={{
                                    sx: { borderRadius: 2 }
                                }}
                            />
                            <FormControl sx={{ width: '100%', mt: 1 }} variant="outlined">
                                <InputLabel htmlFor="contrasena">Contraseña</InputLabel>
                                <OutlinedInput
                                    id="contrasena"
                                    name="contrasena"
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="current-password"
                                    sx={{ borderRadius: 2 }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Contraseña"
                                />
                            </FormControl>

                            <LoadingButton
                                type="submit"
                                fullWidth
                                loading={loading}
                                loadingIndicator="Ingresando…"
                                variant="contained"
                                sx={{
                                    mt: 4,
                                    mb: 2,
                                    py: 1.5,
                                    borderRadius: 2,
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    fontSize: '1rem'
                                }}
                            >
                                <span>Ingresar</span>
                            </LoadingButton>

                            <Copyright sx={{ mt: 2 }} />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}
